export default __webpack_public_path__ + "static/clubChristmasLights-edf2958617eb047847d607e8db6a773c.svg";